import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SortIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M3 4H18.8075V6H3V4Z' fill='currentColor' />
            <Path d='M3 8.07014H14.8556V10.1052H3V8.07014Z' fill='currentColor' />
            <Path d='M3 12.1403H11V14.1754H3V12.1403Z' fill='currentColor' />
            <Path d='M3 16.2104H7V18.2455H3V16.2104Z' fill='currentColor' />
            <Path d='M16.8436 12.1403H18.8195V17.7367H16.8436V12.1403Z' fill='currentColor' />
            <Path d='M21 17.7367L17.8316 21L14.6631 17.7367H21Z' fill='currentColor' />
        </>
    ),
})

SortIcon.displayName = 'SortIcon'
